import { z } from "zod";

const BrowseTargetRolesSchema = z.object({}).strict();

export default BrowseTargetRolesSchema;
